@if (visible) {
<div class="admin-bar">
  <button (click)="toggle()" type="button" id="logout-button" class="admin-bar-close" nz-button nzType="link" nzShape="circle" aria-label="Cerrar">
    <i class="fa fa-times"></i>
  </button>
  <hr />
</div>
}
